import { render } from "./LayoutList.vue?vue&type=template&id=0ab35fa6&scoped=true"
import script from "./LayoutList.vue?vue&type=script&lang=js"
export * from "./LayoutList.vue?vue&type=script&lang=js"

import "./LayoutList.vue?vue&type=style&index=0&id=0ab35fa6&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab35fa6"]])

export default __exports__